import {
  create,
  createBlobs,
  deleteFile,
  get,
  getBlob,
  getByManifest,
  getDraft,
  getFile,
  getJob,
  keepBlobs,
  publish,
} from "./endpoints";

export { service } from "./endpoints";
export {
  AssetVersionId,
  BASEMAP_BLOB_MAX_BYTES,
  BASEMAP_NEW_WORLD_FINEST_LEVEL,
  BASEMAP_PUBLISH_STEPS,
  BasemapBlobHeaders,
  BasemapBlobParams,
  BasemapDraftParams,
  BasemapDraftResponse,
  BasemapFileParams,
  BasemapFileResponse,
  BasemapJob,
  BasemapJobParams,
  BasemapManifestParams,
  BasemapParams,
  type BasemapPublishStep,
  BasemapQuery,
  BasemapResponse,
  CreateBasemapBlobsRequest,
  CreateBasemapBlobsResponse,
  CreateBasemapRequest,
  DeleteBasemapFileRequest,
  KeepBasemapBlobsRequest,
  PublishBasemapRequest,
} from "./schemas";

export const contract = {
  create,
  get,
  manifests: { get: getByManifest },
  drafts: {
    get: getDraft,
    blobs: { create: createBlobs, get: getBlob, keep: keepBlobs },
    publish,
  },
  jobs: { get: getJob },
  files: { get: getFile, delete: deleteFile },
} as const;
